import React from 'react';
import './InstallationList.scss';

interface InstallationListProps {
  children: React.ReactNode;
}

export default function InstallationList({ children }: InstallationListProps) {
  return (
    <ul className='installation-list' aria-label='installation list'>
      {children}
    </ul>
  );
}
